import vest, { enforce, test } from 'vest';
import copy from '../../assets/validation-copy.json';

const validations = {
  sizeLimit: 1024 * 1024 * 20,
  validFileTypes: [
    'image/jpg',
    'image/jpeg',
    'image/png',
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ],
};

function isValidType(file: File) {
  test(
    'type',
    copy.Validations.FileType,
    () => {
      enforce(file.type).inside(validations.validFileTypes);
    },
  );
}

function hasContent(file: File) {
  test(
    'size',
    copy.Validations.FileContent,
    () => {
      enforce(file.size).greaterThan(0);
    },
  );
}

function isValidSize(file: File) {
  test(
    'size',
    copy.Validations.FileSize,
    () => {
      enforce(file.size).lessThan(validations.sizeLimit);
    },
  );
}

const validateFile = vest.create(
  'file-validator',
  (file: File) => {
    hasContent(file);
    isValidSize(file);
    isValidType(file);
  },
);

export default validateFile;
